
export interface CBUserTouchEvent {
    readonly currentTarget?:HTMLDivElement
    readonly clientX:number
    readonly clientY:number
}

export class CBMouseEvent implements CBUserTouchEvent {
    public readonly currentTarget?:HTMLDivElement
    public readonly clientX:number
    public readonly clientY:number

    constructor(event:MouseEvent) {
        this.currentTarget = event.currentTarget as HTMLDivElement
        this.clientX = event.clientX
        this.clientY = event.clientY
    }
}

export class CBTouchEvent implements CBUserTouchEvent {
    public readonly currentTarget?:HTMLDivElement
    public readonly clientX:number
    public readonly clientY:number

    constructor(event:TouchEvent) {
        this.currentTarget = event.currentTarget as HTMLDivElement
        this.clientX = event.touches.length ? event.touches[0].clientX : 0
        this.clientY = event.touches.length ? event.touches[0].clientY : 0
    }
}